/**
 * Voice mapping utility for Aris AI
 * This file contains the mapping between voice options displayed to users
 * and the corresponding OpenAI voice IDs used in the backend
 */

// Voice options with their display names and corresponding OpenAI voice IDs
export const VOICE_OPTIONS = [
  {
    value: "Male",
    label: "Aris (Default)",
    openAIVoice: "ash",
    audioFile: `${process.env.REACT_APP_STATIC_CONTENT}assets/Aris_Male_ash.mp3`
  },
  {
    value: "Female_2",
    label: "Aris (Calm & Clear)",
    openAIVoice: "alloy",
    audioFile: `${process.env.REACT_APP_STATIC_CONTENT}assets/Aris_Female_alloy.mp3`
  },
  {
    value: "Female_1",
    label: "Aris (Encouraging)",
    openAIVoice: "coral",
    audioFile:`${process.env.REACT_APP_STATIC_CONTENT}assets/Aris_Female_coral.mp3`
  },
  {
    value: "Male_2",
    label: "Aris (Gentle & Reflective)",
    openAIVoice: "ballad",
    audioFile:`${process.env.REACT_APP_STATIC_CONTENT}assets/Aris_Male_ballad.mp3`
  }
  // {
  //   value: "Male_1",
  //   label: "Aris (Soulful)",
  //   openAIVoice: "shimmer",
  //   audioFile:`${process.env.REACT_APP_STATIC_CONTENT}assets/d.mp3`
  // }
];

// Function to get OpenAI voice ID from the voice value
export const getOpenAIVoice = (voiceValue) => {
  const voice = VOICE_OPTIONS.find(option => option.value === voiceValue);
  return voice ? voice.openAIVoice : "ash"; // Default to echo if not found
};

// Function to get audio file path from the voice value or openAI voice ID
export const getAudioFile = (voiceValueOrId) => {
  // First try to match by value (e.g., "Female", "Male")
  let voice = VOICE_OPTIONS.find(option => option.value === voiceValueOrId);
  
  // If not found, try to match by openAIVoice ID (e.g., "echo", "ash")
  if (!voice) {
    voice = VOICE_OPTIONS.find(option => option.openAIVoice === voiceValueOrId);
  }
  
  return voice
    ? voice.audioFile
    : `${process.env.REACT_APP_STATIC_CONTENT}assets/Aris_Female_Voice_Echo.mp3`; // Default if not found
};

// Function to get the voice options for dropdown
export const getVoiceOptions = () => {
  return VOICE_OPTIONS.map(option => ({
    value: option.value,
    label: option.label
  }));
};

// Function to get voice option by value OR openAIVoice ID
// This handles cases where the API returns the OpenAI voice ID instead of the value
export const getVoiceOptionByValueOrId = (voiceValueOrId) => {
  if (!voiceValueOrId) return null;
  
  // First try to match by value (e.g., "Female", "Male")
  let voice = VOICE_OPTIONS.find(option => option.value === voiceValueOrId);
  
  // If not found, try to match by openAIVoice ID (e.g., "echo", "ash")
  if (!voice) {
    voice = VOICE_OPTIONS.find(option => option.openAIVoice === voiceValueOrId);
  }
  
  return voice || null;
};